var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-content',[_c('div',{attrs:{"id":"chart"}}),_c('div',[_vm._v("2")]),_c('div',{attrs:{"id":"chart2"}}),_c('svg')])],1)}
var staticRenderFns = []

export { render, staticRenderFns }